export const daysOfWeek = [
    { key: 0, name: 'sunday', label: 'Domingo', isWeekend: true },
    { key: 1, name: 'monday', label: 'Segunda' },
    { key: 2, name: 'tuesday', label: 'Terça' },
    { key: 3, name: 'wednesday', label: 'Quarta' },
    { key: 4, name: 'thursday', label: 'Quinta' },
    { key: 5, name: 'friday', label: 'Sexta' },
    { key: 6, name: 'saturday', label: 'Sábado', isWeekend: true }
];

export const daysOfWeekMondayFirst = [...daysOfWeek].sort(
    (first, second) => (first.key === 0 ? 7 : first.key) - (second.key === 0 ? 7 : second.key)
);

export default daysOfWeek;
